export default __webpack_public_path__ + "static/TX3-ES-c828f7dddb057cbf9b72b8c65e3c0362.svg";